/**
 * 页面内跳转辅助：与 App.tsx 的 popstate 监听协同，不整页刷新。
 * 旧深链（如 /tenants、/audit）继续由 App.tsx 原路由兼容渲染。
 */
export function appNavigate(path: string) {
  if (window.location.pathname === path) return;
  window.history.pushState({}, "", path);
  window.dispatchEvent(new PopStateEvent("popstate"));
  window.scrollTo({ top: 0 });
}
